/*
 * Model for example translation, including the functionality to send request to the server
 * to get english translation for the foreign example text.
 */

define([
  "backbone",
  "jquery",
  "underscore",
  "messaging/messenger",
  "configuration/properties",
], function (Backbone, $, _, Messenger, Properties) {
  "use strict";

  let ExampleTranslationModel = {};

  ExampleTranslationModel.exampleTranslationModel = Backbone.Model.extend({
    defaults: {
      exampleText: "",
      foreignLocaleId: 0,
    },
    getTranslation: function (exampleString, localeId) {
      // it is the responsibility of the caller to make sure exampleString is not empty
      this.set("exampleText", exampleString);
      this.set("foreignLocaleId", localeId);
      this.save();
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return (
        Properties.rootURL +
        "/" +
        kbId +
        "/intents/example/locale/" +
        this.get("foreignLocaleId") +
        "/translation"
      );
    },
  });

  return ExampleTranslationModel;
});
